export enum LugasAreaType {
	SportBetting = "sport-betting",
	Casino = "casino",
}
